import IKUtils from 'innerken-js-utils'

export default {
  ...IKUtils,
}
